import { StoreTheme } from '@/redux/reducers/store';
import { ENDPOINT } from 'src/config/endpoints';
import apiCall from '../../../services/api';

export const fetchEmptyWidgetsHtml = async (widgetId: string) => {
  const widgetResponse = await apiCall.get(
    ENDPOINT.ADDITIONAL_PAGES.getStaticWidgetDetails(widgetId)
  );
  const response = JSON.parse(widgetResponse?.data?.data);
  const html = response.html;
  return html;
};

export const fetchAllWidgetsHtml = async (theme: StoreTheme) => {
  const componentsHTML: Record<string, string> = {};
  const allPromises: Promise<string>[] = [];

  theme?.components?.Body?.filter(
    (component) => component.sub_type === 'StaticWidget'
  ).map((component) => {
    const widgetHtmlPromise = fetchEmptyWidgetsHtml(component.widget_id);
    allPromises.push(widgetHtmlPromise);
    return widgetHtmlPromise.then((widgetHtml) => {
      componentsHTML[component.widget_id] = widgetHtml;
      return widgetHtml;
    });
  });

  await Promise.all(allPromises);

  return componentsHTML;
};
